const publicDeviceModel = {
  'pages.material.material.device-model.addDevice': '',
}
export default publicDeviceModel
